import { useCallback, useEffect, useState } from 'react';

import { Session, TabStatus, useUpdateStudy } from '@app/api';

const defaultValue = {
  [TabStatus.outOfQuota]: [],
  [TabStatus.applied]: [],
  [TabStatus.selected]: [
    'acceptedAt',
    'validatedAt',
    'cancelledAt',
    'reportedAt',
  ],
  [TabStatus.approved]: ['acceptedAt', 'reportedAt'],
  [TabStatus.participated]: ['validatedAt'],
  [TabStatus.gaveUp]: ['acceptedAt', 'cancelledAt'],
  [TabStatus.rejected]: [],
  [TabStatus.other_moderated]: [],
  [TabStatus.other_unmoderated]: [],
};

export const useHiddenColumnsState = (
  tabStatus: TabStatus,
  session: Session,
): [
  string[],
  (state: string[]) => string[],
  (column?: TabStatus) => string[],
] => {
  const { mutate } = useUpdateStudy(session.id, { noInvalidate: true });
  const [state, setState] = useState<Record<TabStatus, string[]>>(
    session.hiddenColumns || defaultValue,
  );

  const setHiddenColumns = useCallback(
    (columns: string[]) => {
      const newState = {
        ...state,
        [tabStatus]: columns,
      };
      setState(newState);
      mutate({ hiddenColumns: newState });
      return columns;
    },
    [tabStatus, setState, mutate, state],
  );

  const setDefault = useCallback(() => {
    return setHiddenColumns(defaultValue[tabStatus]);
  }, [setHiddenColumns, tabStatus]);

  return [state[tabStatus] || [], setHiddenColumns, setDefault];
};
